import { connect } from 'react-redux';
import { dispatchify, recall } from 'common/utils/utils';
import {
  toggleModal,
  createRepositories,
  deleteSensorAuthorization,
  getOrganization,
  toggleSnackBar,
  getJobDetails
} from 'state/callers';
import AddRepositories from './AddRepositories';
import { myAccountSelector } from 'state/selectors/account';
import { shouldStopOnboardingRecall } from 'common/services/http-polling-stopper';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';

const mapStateToProps = state => {
  const { repositories } = state;
  return {
    account: myAccountSelector(state),
    gitSensorAuthorizations: gitIntegrationsSelector(state),
    repositories
  };
};

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    toggleModal,
    createRepositories,
    deleteSensorAuthorization,
    toggleSnackBar,
    getJobDetails
  }),
  ...recall(
    { ...dispatchify(dispatch, { getOrganization }) },
    shouldStopOnboardingRecall,
    20
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(AddRepositories);
